import React from "react";
import downloadIcon from "../assets/res/download.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { GET_BASE_URL } from "../utils/Constants";
import startIcon from "../assets/res/star_icon.svg"

function AppCard({ app, onGameClicked }) {
  return (
    <div className="flex items-center bg-white p-2 rounded-xl mx-4 shadow-secondary shadow-s">
      <div className="flex flex-row">
        <div className="w-[64px] h-[64px] bg-gray-300 rounded-xl mr-4 flex-shrink-0">
          <LazyLoadImage
            src={GET_BASE_URL() + "images/" + app.image}
            className="w-[64px] h-[64px] bg-gray-300 rounded-xl mr-4"
          />
        </div>
        <div className="flex-grow min-w-0">
          <h2 className="text-lg  medium text-m break-words">{app.name}</h2>

          <div className="flex flex-row">
            <div className="text-gray-900 medium text-sm flex ">
              <LazyLoadImage
                src={startIcon}
                className="w-[18px] h-[18px] flex-shrink-0"
              />
              <div>{app.rating}</div>
            </div>
            {app.category === "Mod" &&
              <div className="medium text-xs rounded-lg bg-gray-200 px-2 ml-2">
                {app.category}
              </div>
            }
            {app.category === "Game" &&
              <div className="medium text-xs rounded-lg bg-black text-white px-2 ml-2 ">
                {app.category}
              </div>
            }
            {app.category === "App" &&
              <div className="medium text-xs rounded-lg  text-black border-dark border-[1px] px-2 ml-2">
                {app.category}
              </div>
            }

          </div>

          <p className=" medium text-sm text-primary">
            {app.isForIos && "iOS "} {app.isForIos && app.isForAndroid && "/"}{" "}
            {app.isForAndroid && "Android"}
          </p>
        </div>
      </div>

      <button
        className="ml-auto  h-[40px] w-[40px] bg-primary text-white pl-[10px] rounded-full flex-shrink-0"
        onClick={onGameClicked}
      >
        <img src={downloadIcon} className="h-[20px] w-[20px]" />
      </button>
    </div>
  );
}

export default AppCard;
